// src/App.js
// ─────────────────────────────────────────────────────────────
// Root component. Two views:
//   1. Landing / Wizard  (when !wizard.completed)
//   2. Directory         (when wizard.completed)
//
// The wizard hook lives here so its state survives
// the transition between views and can be passed to both.
// ─────────────────────────────────────────────────────────────

import React, { useEffect } from 'react';
import { useWizard } from './hooks/useWizard';
import WizardFlow from './components/wizard/WizardFlow';
import DirectoryView from './components/directory/DirectoryView';
import { seedPrograms } from './lib/schema';
import './styles/global.css';

export default function App() {
  const wizard = useWizard();

  // ── Seed database on first load (remove after first run) ──
  // Uncomment the line below, run the app once, then comment it out again.
  //useEffect(() => { seedPrograms(); }, []);

  return (
    <div className="app">
      {!wizard.completed ? (
        <WizardFlow wizard={wizard} />
      ) : (
        <DirectoryView wizard={wizard} />
      )}
    </div>
  );
}
